import {Injectable} from '@angular/core';
import {Betreuer} from '@pezi/entities';
import {createStore, withProps} from "@ngneat/elf";
import {persistState, sessionStorageStrategy} from "@ngneat/elf-persist-state";

export interface ActiveBetreuerknotenState {
  betreuerknoten: Betreuer;
  loading: boolean;
  errorLoading: boolean;
}

export function createInitialState(): ActiveBetreuerknotenState {
  return {
    betreuerknoten: undefined,
    loading:        false,
    errorLoading:   false
  };
}

@Injectable({providedIn: 'root'})
export class ActiveBetreuerknotenStore {

  data = createStore({name: 'active-betreuerknoten'}, withProps<ActiveBetreuerknotenState>(createInitialState()));
  persist = persistState(this.data, {
    key: 'active-betreuerknoten',
    storage: sessionStorageStrategy,
  });

}

